import { cva } from 'class-variance-authority';

export const stackStyle = cva('flex', {
  variants: {
    alignContent: {
      'flex-start': 'content-start',
      'flex-end': 'content-end',
      center: 'content-center',
      'space-between': 'content-between',
      'space-around': 'content-around',
      'space-evenly': 'content-evenly',
      stretch: 'content-stretch',
      start: 'content-start',
      end: 'content-end',
      normal: 'content-normal',
      baseline: 'content-baseline',
      between: 'content-between',
      around: 'content-around',
      evenly: 'content-evenly',
    },

    alignItems: {
      'flex-start': 'items-start',
      center: 'items-center',
      'flex-end': 'items-end',
      stretch: 'items-stretch',
      baseline: 'items-baseline',
      start: 'items-start',
      end: 'items-end',
    },

    direction: {
      row: 'flex-row',
      'row-reverse': 'flex-row-reverse',
      column: 'flex-col',
      'column-reverse': 'flex-col-reverse',
    },

    flexWrap: {
      wrap: 'flex-wrap',
      nowrap: 'flex-nowrap',
      'wrap-reverse': 'flex-wrap-reverse',
    },

    justifyContent: {
      'flex-start': 'justify-start',
      start: 'justify-start',
      center: 'justify-center',
      'flex-end': 'justify-end',
      end: 'justify-end',
      'space-between': 'justify-between',
      'space-around': 'justify-around',
      'space-evenly': 'justify-evenly',
      stretch: 'justify-stretch',
      normal: 'justify-normal',
      between: 'justify-between',
      around: 'justify-around',
      evenly: 'justify-evenly',
    },

    justifyItems: {
      start: 'justify-items-start',
      center: 'justify-items-center',
      end: 'justify-items-end',
      stretch: 'justify-items-stretch',
      normal: 'justify-items-normal',
    },
  },
});
